import {getProjectDocumentsOdataQuery, getDocumentDetailsOdataQuery, getDocumentRevisionOdataQuery, getDocumentFilesOdataQuery, getEngOrderIdByIdsOdataQuery, getStakeHolderIdsByCompaniesQuery, getProjectDocumentsByTransmittalOdataQuery} from './odataDocumentQueries'
import {configuration} from '../configuration'
import { Filters } from '../models/filters';
import { Status } from '../models/status';
import { HistoryPathType } from './costants';

export const getTransmittalUrl = (transmittalId: string): string => {
    return `${configuration.transmittal_url}/${encodeURIComponent(transmittalId)}`;
};

// GET
export const getProjectDocumentsUrl = (projectId: number, filters: Filters, orderColumn: {name: string, direction: string}, skip: number, allStatus: Status[], historyName: HistoryPathType, documentIds?: number[], onlyIds?: boolean, supplierCompany?: string, partnerId?: number, customerId?: number): string => {
    const query = getProjectDocumentsOdataQuery(projectId, filters, orderColumn, skip, allStatus, historyName, documentIds, onlyIds, supplierCompany, partnerId, customerId) as string;
    return `${configuration.api_endpoint}/Documents${(query) ? query : ''}`;
}; 
export const getCheckTransmittalUrl = (projectId: number, transmittalId: string): string => {
    const query = getProjectDocumentsByTransmittalOdataQuery(projectId, transmittalId) as string;
    return `${configuration.api_endpoint}/Documents${(query) ? query : ''}`;
};
export const getDocumentDetailsUrl = (projectId: number, documentId: number): string => {
    const query = getDocumentDetailsOdataQuery(projectId, documentId) as string;
    return `${configuration.api_endpoint}/Documents${(query) ? query : ''}`;
}; 
export const getDocumentRevisionsUrl = (projectId: number, currentRevision: string, sheet: number, documentNumber: string, sapPart: string): string => {
    const query = getDocumentRevisionOdataQuery(projectId, currentRevision, sheet, documentNumber, sapPart) as string;
    return `${configuration.api_endpoint}/Documents${(query) ? query : ''}`;
}; 
export const getDocumentFilesUrl = (projectId: number, documentId: number): string => {
    const query = getDocumentFilesOdataQuery(projectId, documentId) as string;
    return `${configuration.api_endpoint}/Documents${(query) ? query : ''}`;
}; 
export const getActionHistoryUrl = (documentId: number): string => {
    return `${configuration.api_endpoint}/ActionHistory?$filter=DocumentId%20eq%20${documentId}&$expand=Action&$orderby=Date%20desc`;
};
export const downloadFileUrl = (documentId: string): string => {
    return `${configuration.api_endpoint}/ExodItem/${documentId}` ;
}; 
export const getEngOrderIdByIdsUrl = (projectId: number, documentNumbers: string[]): string => {
    const query = getEngOrderIdByIdsOdataQuery(projectId, documentNumbers) as string;
    return `${configuration.api_endpoint}/Documents${(query) ? query : ''}`;
}; 
export const getStakeholderIdsByCompaniesUrl = (companies: string[]): string => {
    const query = getStakeHolderIdsByCompaniesQuery(companies) as string;
    return `${configuration.api_endpoint}/StakeHolders${(query) ? query : ''}`;
}; 

// POST
export const uploadFilesUrl = (): string => {
     return `${configuration.api_endpoint}/ExodItem` ;
}; 
export const addCommentUrl = (): string => {
    return `${configuration.api_endpoint}/Comment` ;
}; 
export const downloadFilesUrl = (): string => {
    return `${configuration.api_endpoint}/DownloadAllFiles` ;
}; 
export const downloadCommentsUrl = (): string => {
    return `${configuration.api_endpoint}/DownloadComments` ;
}; 
export const downloadExcelReportUrl = (): string => {
    return `${configuration.api_endpoint}/CreateReport` ;
}; 
export const reportDownloadsUrl = (email?: string): string => {
    const sanitizedEmail = (email || '').replace(/'/g, "''");
    return `${configuration.api_endpoint}/ReportDownloads?$filter=${encodeURIComponent(`Email eq '${sanitizedEmail}'`)}&$orderby=${encodeURIComponent('CreatedUtc desc')}`;
};
export const reportDownloadStatusUrl = (jobId: string): string => {
    return `${configuration.api_endpoint}/CreateReport/${jobId}`;
};
export const downloadSSABExcelReportUrl = (): string => {
    return `${configuration.api_endpoint}/SsabTemplate` ;
}; 
export const downloadSupplierTemplateUrl = (): string => {
    return `${configuration.api_endpoint}/DownloadTemplate` ;
}; 
export const projectDownloadsUrl = (): string => {
    return `${configuration.api_endpoint}/ProjectDownloads`;
};
export const projectDownloadStatusUrl = (jobId: string): string => {
    return `${configuration.api_endpoint}/ProjectDownloads/${jobId}`;
};
export const projectDownloadFileUrl = (jobId: string): string => {
    return `${configuration.api_endpoint}/ProjectDownloads/${jobId}/download`;
};
export const resolveProjectDownloadUrl = (url?: string | null): string | undefined => {
    if(!url)
        return undefined;
    if(url.startsWith('http://') || url.startsWith('https://'))
        return url;
    try {
        return `${new URL(configuration.api_endpoint).origin}${(url.startsWith('/')) ? url : '/' + url}`;
    }
    catch {
        return url;
    }
};
export const changeStatusUrl = (): string => {
    return `${configuration.api_endpoint}/StatusHistory` ;
}; 
export const reserveNumberSupplierUrl = (): string => {
    return `${configuration.api_endpoint}/ReserveForSupplier ` ;
}; 
export const importZipSupplierUrl = (): string => {
    return `${configuration.api_endpoint}/ImportZip` ;
}; 
export const importZipPartnerUrl = (): string => {
    return `${configuration.api_endpoint}/ImportZipPartner` ;
}; 
export const supplierUploadUrl = (): string => {
    return `${configuration.api_endpoint}/SupplierDocument` ;
}; 
export const partnerUploadUrl = (): string => {
    return `${configuration.api_endpoint}/PartnerDocument` ;
}; 
export const reserveNumbersUrl = (): string => {
    return `${configuration.api_endpoint}/PartnerReserve` ;
}; 
export const newSheetUrl = (): string => {
    return `${configuration.api_endpoint}/CreateSheet` ;
}; 
export const newRevisionUrl = (): string => {
    return `${configuration.api_endpoint}/CreateIndex` ;
}; 
export const newEeoRevisionUrl = (): string => {
    return `${configuration.api_endpoint}/CreateEEORevision` ;
}; 
export const newEditDeleteFolderUrl = (folderId?: string): string => {
    return `${configuration.api_endpoint}/Folder` + ((folderId) ? ('/' + folderId) : '') ;
}; 
export const addDocumentsToFolderUrl = (): string => {
    return `${configuration.api_endpoint}/DocumentFolder`;
}; 
export const removeDocumentsFromFolderUrl = (): string => {
    return `${configuration.api_endpoint}/RemoveDocumentFolder`;
}; 

// PUT
export const editDocumentUrl = (): string => {
    return `${configuration.api_endpoint}/Document` ;
}; 
export const editDocumentsUrl = (): string => {
    return `${configuration.api_endpoint}/BatchEditDocuments` ;
}; 
export const replaceFileUrl = (replaceId: string): string => {
    return `${configuration.api_endpoint}/ExodItem/${replaceId}` ;
}; 
export const saveLanguageUrl = (isEdit: boolean): string => {
    return (isEdit) ? `${configuration.api_endpoint}/EditLanguage` : `${configuration.api_endpoint}/CreateLanguage`;
}; 
export const generateNumberAndPartUrl = (): string => {
    return `${configuration.api_endpoint}/RequestDocNumber` ;
}; 
export const generatePartUrl = (): string => {
    return `${configuration.api_endpoint}/RequestSapPart` ;
}; 
export const saveFileTypeUrl = (isEdit: boolean): string => {
    return (isEdit) ? `${configuration.api_endpoint}/EditFileType` : `${configuration.api_endpoint}/CreateFileType`;
}; 

// DELETE
export const deleteFileUrl = (fileId: string): string => {
    return `${configuration.api_endpoint}/ExodItem/${fileId}` ;
}; 
export const deleteDocumentsUrl = (): string => {
    return `${configuration.api_endpoint}/Document` ;
}; 

